import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { Set as ImmutableSet } from 'immutable';
import { connect, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { NavMarker } from 'react-rhumb'; // @ts-expect-error cannot find declaration file

import FeedbackLoader from 'feedback-loader'; // @ts-expect-error cannot find declaration file

import withQueryParams from 'AdsUI/lib/withQueryParams'; // @ts-expect-error cannot find declaration file

import { trackEvent } from 'AdsUI/lib/usageTracker'; // @ts-expect-error cannot find declaration file

import AdsSafeStorage from 'AdsUI/lib/AdsSafeStorage';
import { SEEN_A_GOALS_CSAT // @ts-expect-error cannot find declaration file
} from 'AdsUI/lib/StorageKeys'; // @ts-expect-error cannot find declaration file

import { isQA } from 'AdsUI/lib/Constants'; // @ts-expect-error cannot find declaration file

import { postNotification } from 'ReduxMessenger/actions/NotificationActions';
import { ADS_GOAL_TYPES } from 'goals-reporting-lib/constants/ads';
import { GOAL_STATUS, GOAL_MILESTONE } from 'goals-reporting-lib/constants/goals';
import { getAdAccountAssetId, DEFAULT_GOAL_TYPE } from 'AdsUI/lib/Goals';
import { toFormattedString // @ts-expect-error cannot find declaration file
} from 'UIComponents/core/SimpleDate'; // @ts-expect-error cannot find declaration file

// @ts-expect-error cannot find declaration file
import AdAccountStatus from 'ads-account-connection/lib/AdAccountStatus';
import UIDashboardPage from 'UIComponents/page/UIDashboardPage';
import GoalsTable from 'goals-reporting-lib/components/goals-table';
import AnalyzeSidebar from 'AdsUI/components/AnalyzeSidebar'; // @ts-expect-error cannot find declaration file

import DashboardNavigation from 'AdsUI/components/DashboardNavigation'; // @ts-expect-error cannot find declaration file

import DashboardNavigationItems from 'AdsUI/lib/DashboardNavigationItems';
import { hasAdsGoalsReadAccess // @ts-expect-error cannot find declaration file
} from 'AdsUI/selectors/AuthSelectors';
import GoalsFilters from 'AdsUI/components/goals/GoalsFilters';
import { getConnectedUsers, getAdAccounts // @ts-expect-error cannot find declaration file
} from 'AdsUI/selectors/AccountsSelectors';
import FormattedMessage from 'I18n/components/FormattedMessage';
const GOAL_DURATIONS = [GOAL_MILESTONE.MONTHLY, GOAL_MILESTONE.QUARTERLY, GOAL_MILESTONE.YEARLY];
const GOAL_CREATION_SURVEY_ID = isQA ? 303 : 905;
const GOAL_PAGE_SURVEY_ID = isQA ? 304 : 906;

const GoalsContainer = ({
  canReadAdsGoals,
  adAccounts,
  connectedUsers,
  query,
  setQueryParam,
  deleteQueryParam
}) => {
  const dispatch = useDispatch();
  const successfulCreation = query.get('success');
  const goalType = query.get('goalType');
  const [selectedGoalType, setSelectedGoalType] = useState(DEFAULT_GOAL_TYPE);
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: null,
    endDate: null
  });
  const [selectedAdAccounts, setSelectedAdAccounts] = useState(ImmutableSet([]));
  const [selectedDurations, setSelectedDurations] = useState(ImmutableSet(GOAL_DURATIONS));
  const [selectedStatuses, setSelectedStatuses] = useState(ImmutableSet(Object.values(GOAL_STATUS)));
  const [selectedProgress, setSelectedProgress] = useState({
    minPercentage: null,
    maxPercentage: null
  });

  const handleUpdateGoalTypeFilter = ({
    target: {
      value
    }
  }) => {
    trackEvent('goalsTableFilter', {
      action: 'Changed goal type filter',
      goalType: value
    });
    setQueryParam('goalType', value);
    setSelectedGoalType(value);
  };

  const handleUpdateDateFilter = ({
    target: {
      value
    }
  }) => {
    trackEvent('goalsTableFilter', {
      action: 'Changed end date filter',
      startDate: toFormattedString(value.startDate, 'YYYY-MM-DD'),
      endDate: toFormattedString(value.endDate, 'YYYY-MM-DD')
    });
    setSelectedDateRange(value);
  };

  const handleUpdateAdAccountFilter = adAccountList => {
    trackEvent('goalsTableFilter', {
      action: 'Changed ad account filter',
      adAccountList: adAccountList.toArray()
    });
    setSelectedAdAccounts(adAccountList);
  };

  const handleUpdateDurationFilter = durations => {
    trackEvent('goalsTableFilter', {
      action: 'Changed duration filter',
      duration: durations.toArray()
    });
    setSelectedDurations(durations);
  };

  const handleUpdateStatusFilter = statuses => {
    trackEvent('goalsTableFilter', {
      action: 'Changed status filter',
      status: statuses.toArray()
    });
    setSelectedStatuses(statuses);
  };

  const handleUpdateProgressFilter = (selectedMinProgress, selectedMaxProgress) => {
    trackEvent('goalsTableFilter', {
      action: 'Changed progress filter',
      progressMin: selectedMinProgress,
      progressMax: selectedMaxProgress
    });
    setSelectedProgress({
      minPercentage: selectedMinProgress,
      maxPercentage: selectedMaxProgress
    });
  };

  useEffect(() => {
    setSelectedAdAccounts(adAccounts.filter(account => account.accessibleToPrimaryUser && account.status === AdAccountStatus.ACTIVE).toSet());
  }, [adAccounts]);
  const showGoalsSurvey = useCallback(CSAT_ID => {
    // @ts-expect-error Property does not exist
    if (!window.hsFeedback || !window.hsFeedback.loadSurvey) {
      // eslint-disable-next-line @typescript-eslint/no-implied-eval
      window.setTimeout(showGoalsSurvey, 1000);
      return;
    } // @ts-expect-error Property does not exist


    window.hsFeedback.loadSurvey('CSAT', CSAT_ID);
    AdsSafeStorage.setItem(SEEN_A_GOALS_CSAT, String(Date.now()));
  }, []);
  useEffect(() => {
    if (successfulCreation) {
      dispatch(postNotification({
        id: 'goal-creation-redirect-success',
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "goalsDashboard.successHeader"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "goalsDashboard.successMessage"
        }),
        type: 'success'
      }));
      trackEvent('goalCreationAction', {
        action: 'Finished goal creation',
        goalType
      });
      deleteQueryParam(['success', 'goalTargetObjectId']);
      showGoalsSurvey(GOAL_CREATION_SURVEY_ID);
    }
  }, [successfulCreation, dispatch, deleteQueryParam, goalType, showGoalsSurvey]);
  useEffect(() => {
    const lastSeenGoalsSurvey = AdsSafeStorage.getItem(SEEN_A_GOALS_CSAT);
    const currentTimestamp = Date.now();
    const SEVEN_DAYS = 7 * 24 * 60 * 60 * 1000;

    if (lastSeenGoalsSurvey && currentTimestamp - Number(lastSeenGoalsSurvey) < SEVEN_DAYS) {
      return;
    }

    showGoalsSurvey(GOAL_PAGE_SURVEY_ID);
  }, [showGoalsSurvey]);
  useEffect(() => {
    if (goalType && ADS_GOAL_TYPES.includes(goalType)) {
      setSelectedGoalType(goalType);
    }
  }, [goalType]);

  if (!canReadAdsGoals) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: "/"
    });
  }

  const adAccountAssetIds = selectedAdAccounts.map(getAdAccountAssetId).toArray();
  const usingProgressFilter = selectedProgress.minPercentage && selectedProgress.maxPercentage;
  return /*#__PURE__*/_jsxs(UIDashboardPage, {
    headerComponent: /*#__PURE__*/_jsx(DashboardNavigation, {
      activeItem: DashboardNavigationItems.DASHBOARD
    }),
    sidebarComponent: /*#__PURE__*/_jsx(AnalyzeSidebar, {}),
    pageLayout: "full-width",
    children: [/*#__PURE__*/_jsx(GoalsFilters, {
      handleUpdateGoalTypeFilter: handleUpdateGoalTypeFilter,
      handleUpdateDateFilter: handleUpdateDateFilter,
      handleUpdateAdAccountFilter: handleUpdateAdAccountFilter,
      handleUpdateDurationFilter: handleUpdateDurationFilter,
      handleUpdateStatusFilter: handleUpdateStatusFilter,
      handleUpdateProgressFilter: handleUpdateProgressFilter,
      selectedGoalType: selectedGoalType,
      selectedDateRange: selectedDateRange,
      selectedAdAccounts: selectedAdAccounts,
      adAccounts: adAccounts,
      connectedUsers: connectedUsers,
      selectedDurations: selectedDurations,
      selectedStatuses: selectedStatuses,
      selectedProgress: selectedProgress
    }), /*#__PURE__*/_jsx(GoalsTable, Object.assign({
      goalType: selectedGoalType,
      endDateRange: selectedDateRange,
      status: selectedStatuses.toArray(),
      milestone: selectedDurations.toArray(),
      adAccounts: adAccountAssetIds
    }, usingProgressFilter ? {
      percentProgressRange: selectedProgress
    } : {})), /*#__PURE__*/_jsx(NavMarker, {
      name: "GOALS_TABLE_LOADED"
    }), /*#__PURE__*/_jsx(FeedbackLoader, {
      clientLoadOnly: false
    })]
  });
};

export default connect(state => ({
  canReadAdsGoals: hasAdsGoalsReadAccess(state),
  adAccounts: getAdAccounts(state),
  connectedUsers: getConnectedUsers(state)
}))(withQueryParams(GoalsContainer));